import { render, staticRenderFns } from "./PostGainsComponent.vue?vue&type=template&id=47de1a5a&"
import script from "./PostGainsComponent.vue?vue&type=script&lang=ts&"
export * from "./PostGainsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47de1a5a')) {
      api.createRecord('47de1a5a', component.options)
    } else {
      api.reload('47de1a5a', component.options)
    }
    module.hot.accept("./PostGainsComponent.vue?vue&type=template&id=47de1a5a&", function () {
      api.rerender('47de1a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/Gains/PostGainsComponent.vue"
export default component.exports